import { gql } from '@apollo/client'

const UPDATE_NONPROFIT_ORG_PROFILE = gql`
  mutation UpdateNonprofitOrgProfile(
    $updateNonprofitOrgProfileInput: UpdateNonprofitOrgProfileInput
  ) {
    updateNonprofitOrgProfile(
      updateNonprofitOrgProfileInput: $updateNonprofitOrgProfileInput
    ) {
      confirmedAreasOfImpact
      confirmedOrgSummary
      nonprofitOrgId
    }
  }
`

export default UPDATE_NONPROFIT_ORG_PROFILE
